import { createPivotTransformer } from './create-pivot-transformer';

/** Pivot = Hz. GHz has no catalog entry (target-only). */
export const FREQUENCY_PIVOT: Record<string, number> = {
  hz: 1,
  khz: 1000,
  mhz: 1000000,
  ghz: 1000000000,
};

export const transformFrequency = createPivotTransformer(FREQUENCY_PIVOT);
